{
  "all-listings": {
    "disconnected": {
      "text": "Create an account or log in to view resources available on Partage Agricole network."
    },
    "needLogin": {
      "secondLine": "Create an account or log in to view resources available on Partage Agricole network."
    },
    "empty": {
      "offer": {
        "firstLine": "Start your adventure here!",
        "primaryButtonText": "Post an offer!",
        "secondLine": "Join the catalog by offering items to lend."
      },
      "invite": {
        "primaryButtonText": "Invite other members",
        "secondLine": "Invite other members or publish an offer in your club."
      }
    },
    "banner": {
      "xmas": {
        "text": "The holidays are approaching! Help other members find these frequently requested items."
      }
    },
    "inviteOthersPrompt": {
      "ctaButton": "Invite other members"
    },
    "postOfferPrompt": {
      "firstAfter": {
        "button": "Invite other members",
        "title": "Invite other members!"
      },
      "third": {
        "title": "Ask other members"
      }
    }
  },
  "common": {
    "appName": "Partage Agricole",
    "appDownloadPrompt": {
      "guest": "Like what you see? Get Partage Agricole on your phone and receive new availability near you",
      "qrCodeAccessibilityLabel": "QR code to download the Partage Agricole app"
    }
  },
  "contact-information": {
    "prompt": "Add your business postal code to see which items are available nearby.",
    "title": "Your address",
    "prompt-public": "Add your postal code to see listings available nearby.",
    "title-public": "Your postal code"
  },
  "contact-us": {
    "firstParagraph": "Partage Agricole member service is available by email and in-app messaging. We will respond to you as quickly as possible.",
    "faqLink": "https://www.partageagricole.ca/faq",
    "chatPrompt": {
      "bugReport": "Hi! 😊\n\nThanks for explaining what's wrong.",
      "suggestion": "Hi! 😊\n\nWe're always open to suggestions. Thank you for helping us improve our service.\n\nThanks!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Only Partage Agricole partners can use this app. To get the invitation code, contact <a>Partage Agricole</a>.",
    "activationCodeFieldHelpLink": "https://www.partageagricole.ca/s-inscrire"
  },
  "guidelines": {
    "fifthParagraph": "Do not use Partage Agricole to sell items.",
    "startingKit": "I want to receive the <startingKitLink>Starting Kit</startingKitLink> by mail to recruit other members (optional)"
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Joined Partage Agricole",
        "title": "Explorer"
      }
    }
  },
  "introModal": {
    "title": "Hello {{name}},",
    "first": "Thank you for joining the community and taking your first step toward reducing your consumption and building new connections!",
    "second": "<strong>Sharing is a sign of trust</strong> : the more you lend, the more others will want to lend to you!",
    "third": "<strong>Know that less than 0.1% of all shares</strong> result in damage. And it's not out of bad faith—it's just normal when items get a bit more use.",
    "notInsurable": {
      "community": "<strong>It’s the perfect opportunity to connect with other members</strong> and take a step toward a more sustainable world."
    },
    "welcome": {
      "withWho": {
        "enterprise": "your colleagues and other members",
        "municipal": "other members",
        "municipal_closed": "other members",
        "realestate": "other members"
      }
    }
  },
  "my-information": {
    "firstNameFieldLabel": "Business name",
    "credentialInformationTitle": "Account & security",
    "personalInformationTitle": "Profile information"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Business name",
    "firstNameFieldPlaceholder": "e.g., Ferme de la Tour d'Argent",
    "title": "Profile information"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Your subscription to this sharing app is courtesy of Partage Agricole."
      },
      "title": {
        "enterprise": "Partage Agricole Subscription"
      }
    },
    "noEnd": "This subscription is valid as long as you are a Partage Agricole member.",
    "design": {
      "freeBorrowDescription": "Borrow your first item from other members for free",
      "unlimitedLendingDescription": "Publish offers and lend your items to other members as often as you like"
    }
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "e.g., Garden tractor",
      "descriptionFieldPlaceholder": {
        "offer": "Brand, dimensions, color, weight, condition, year acquired, lending terms, specific features of the item...",
        "request": "Brand, dimensions, color, weight, condition, year acquired, lending terms, specific features of the item..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Welcome to the club",
        "body": "Discover Partage Agricole!"
      }
    },
    "welcome": "Welcome to Partage Agricole!",
    "welcomeMessage": "Thank you for your trust.",
    "rate": {
      "borrower": {
        "message": "Your feedback is important to us and to other members of Partage Agricole."
      },
      "lender": {
        "message": "Your feedback is important to us and to other members of Partage Agricole."
      }
    },
    "loanReciprocity": {
      "message": "Post the items you rarely use and share them with other members."
    }
  },
  "offerAvailability": {
    "refrainPopup": {
      "hi": "Dear member,",
      "text": {
        "lender": {
          "before": "Don't forget to book your work dates and plan your transportation days when making your reservation.",
          "after": "Don't forget to book your work dates and plan your transportation days."
        },
        "borrower": "Don't forget to plan your setup and takedown days when borrowing."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "The need has been fulfilled on Partage Agricole"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Business name",
    "firstNameFieldPlaceholder": "e.g., Ferme de la Tour d'Argent",
    "pictureFieldSubtitle": "This image will appear in your listings and your profile.",
    "pictureFieldTitle": "Add a logo image for your business",
    "title": "Profile information",
    "firstNameFieldLabel-public": "First name",
    "firstNameFieldPlaceholder-public": "First name",
    "lastNameFieldLabel-public": "Last name",
    "lastNameFieldPlaceholder-public": "Last name",
    "phoneFieldLabel-public": "Phone number (optional)",
    "pictureFieldSubtitle-public": "The profile picture increases trust between members",
    "pictureFieldTitle-public": "Add a profile picture",
    "title-public": "Your personal information"
  },
  "privacy": {
    "link1": "https://www.partageagricole.ca/termes-et-conditions",
    "link2": "https://www.partage.club/politique-de-confidentialite",
    "line3": "by Partage Agricole."
  },
  "quick-new-thanks": {
    "bodyText": "You’ve just contributed to enriching the <strong>Partage Agricole</strong> catalog! \n\nYou can modify your offers at any time in your sharing center."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contact Partage Agricole"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "By offering your items, you even encourage the shyest farmers to make requests."
      }
    },
    "publishOffers": {
      "step2": {
        "text": "By offering your items, you even encourage <strong>the shyest members</strong> to ask. You can always lend your items, even <strong>without a subscription</strong>.\n\nTap the icon to continue. (2/5)"
      },
      "step2AltCorp": {
        "text": "By offering your items, you even encourage <strong>the shyest members</strong> to ask.\n\nTap the icon to continue. (2/5)"
      }
    }
  },
  "free-sub": {
    "inviteButtonText": "Invite other members",
    "spreadTheLoveText": "Tell other members about it so they can also enjoy the special offer!"
  },
  "help": {
    "borrower": {
      "steps": {
        "catalog": {
          "text": "Search for an item in the catalog or post a need visible to other members"
        },
        "meeting": {
          "text": "Propose and confirm borrowing and pickup dates with the other member"
        },
        "pickup": {
          "text": "Meet the other member at their home or in a safe public place. <strong>No money changes hands — it's free!</strong>"
        }
      }
    },
    "guestCta": {
      "text": "Join other members and discover what you can borrow nearby."
    },
    "lender": {
      "steps": {
        "share": {
          "text": "Meet the other member at your home or in a safe public place to hand over the item. <strong>No money changes hands — it's free!</strong>"
        }
      }
    }
  },
  "invite": {
    "referralProgram": {
      "shareText": "Hey!\n\nI’ve been using Partage Agricole, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "referralProgram202506": {
      "shareText": "Hey!\n\nI’ve been using Partage Agricole, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}"
    },
    "shareText": "Hey!\n\nI’ve been using Partage Agricole, an app to share everyday items. It’s super handy and I’m sure you’ll love it. Join me:\n\n{{url}}",
    "title": "Invite other members or relatives!"
  },
  "landing-page": {
    "immature": {
      "referral": {
        "button": "Invite other members"
      }
    },
    "requests": {
      "emptyState": {
        "subtitle": "We will notify you if other members need help"
      }
    }
  },
  "loans": {
    "past": {
      "savings": {
        "header": {
          "lending": "Saved by other members thanks to you"
        }
      }
    }
  },
  "my-impact-financial": {
    "empty": {
      "lending": {
        "secondLine": "Share your items and see how much money you allow other members to save!"
      }
    },
    "emptyByTransaction": {
      "lend": {
        "lending": {
          "secondLine": "Share your items and see how much money you allow other members to save!"
        }
      }
    }
  },
  "my-neighbourhood": {
    "radiusDescription": "Your radius allows you to share your listings within a limited area of your neighbourhood. Members living outside of this zone will not be able to see your listings."
  },
  "one-channel": {
    "howItWorks": {
      "borrow": {
        "step2": "<bold>Suggest</bold> borrowing dates, <bold>wait for confirmation</bold> from the other member then <bold>plan the pickup</bold> together",
        "step3": "<bold>Pick up the item</bold> from the other member or at a safe public place. <bold>No money exchanged, it's free!</bold>"
      },
      "lend": {
        "step3": "<bold>Lend the item</bold> to the other member. <bold>No money exchanged, it's free!</bold>"
      }
    }
  },
  "payment": {
    "modal": {
      "firstParagraph": "Thanks for trusting us. With your subscription, you can now borrow and lend unlimited items with other members."
    }
  },
  "posts": {
    "feed": {
      "endOfFeed": {
        "description": "A borrowed item, a new connection…\nShare your story with other members."
      }
    },
    "storyComposer": {
      "neighbour": "a member"
    }
  },
  "presentCommunity": {
    "newFlow": {
      "oneFreeBorrowDescription": "Borrow your first item from a member for free",
      "unlimitedLendingDescription": "Post offers and lend your items to members as often as you like"
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Partage Agricole is the application for <strong>sharing objects</strong> between members."
    }
  },
  "profile-overview": {
    "inviteNeighboursButtonLabel": "Invite members"
  },
  "recommendations": {
    "urgent-needs": {
      "title": "Help other members!"
    }
  },
  "streak": {
    "contributions": {
      "add_avatar": {
        "description": "A profile picture reassures other members and makes you recognisable in the community."
      },
      "dismiss_request": {
        "title": "Try to help other members"
      },
      "publish_offer": {
        "description": "Publish a specific item, or choose from suggested items already shared by our members!"
      },
      "send_message": {
        "description": "Break the ice! Write to a member to offer help or learn more about a listing."
      }
    },
    "neighbourhoodFirstShare": "In your neighbourhood, <strong>{{percent}}% of other members</strong> made their first share <strong>in less than a week</strong>",
    "objectiveDetails": "The objective for the month is determined based on the number of sharing members around you and the maturity of your neighbourhood.",
    "seriesDetails": "To keep the sharing flame alive, you and other members must reach the indicated sharing goal for the month.",
    "tips": {
      "helpNeighbours": {
        "title": "Try to help other members"
      }
    }
  }
}
